import { Card, CardContent, Button } from '@exam-prep/ui';
import { Loading } from '../../../components/Feedback';
import { useGmLearner } from '../hooks/useGmLearner';
import { useNow } from '../hooks/useNow';
import { GM } from '../model/copy';
import { deriveStage, streakOf } from '../model/flow';
import { GmFacts, StreakTracker } from '../ui/GrandMockParts';

/** The Hub card: the next SSC Rankers League at a glance. Fixed height while loading (no layout shift). */
export function GrandMockHubCard({ onOpen }: { onOpen: () => void }) {
  const { data, offset, error, reload } = useGmLearner();
  const now = useNow(60_000);
  if (error && !data)
    return (
      <Card className="min-h-28">
        <CardContent className="flex items-center justify-between gap-3 pt-4 text-sm">
          <span>{GM.loadError}</span>
          <Button variant="outline" size="sm" onClick={reload}>
            {GM.retry}
          </Button>
        </CardContent>
      </Card>
    );
  if (!data)
    return (
      <Card className="min-h-28" aria-busy="true">
        <CardContent className="pt-0">
          <Loading />
        </CardContent>
      </Card>
    );
  const gm = data.grandMock;
  const stage = deriveStage(data, now + offset);
  // No League announced: the hub simply has no League card.
  if (!gm) return null;
  const streak = streakOf(data.me);
  return (
    <Card className="live-card min-h-28">
      <CardContent className="space-y-2 pt-4 text-sm">
        <p className="font-display text-base font-semibold">
          {GM.title}: {gm.examName}
        </p>
        <p className="text-muted-foreground">{GM.extra}</p>
        <GmFacts gm={{ ...gm, joinWindowMin: 0 }} />
        {stage.kind === 'not_eligible' && streak ? <StreakTracker streak={streak} /> : null}
        <Button className="w-full" onClick={onOpen}>
          {stage.kind === 'in_progress'
            ? 'Resume the exam'
            : stage.kind === 'results'
              ? 'See results'
              : GM.open}
        </Button>
      </CardContent>
    </Card>
  );
}
